import moment from "moment";
import {first} from "rxjs/operators";
import ObjectCopyService from "external-services/object-copy-service/index";
import {PaymentTypes} from "../../app.types";
import AdminService from "external-services/diary-admin-service/admin.service";
import ServiceGroupsService from "external-services/service-groups-service/serviceGroups.service";
import BookingsAffectedService from "app/services/bookingsAffected/bookingsAffected.service";
import {ScheduleFilterService} from "external-services/schedule-filter-service/scheduleFilter.service";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import LayoutsService from 'external-services/layouts-service/layouts.service';
import DateUtilsService from 'external-services/date-utils-service';
import PouchLoadService from "external-services/pouch-load-service";
import CustomIntervalsService from "app/services/customIntervals/customIntervals.service";
import {WHOLE_NUMBER_REGEX} from "appRoot/app.constants";

const NS = 'EditScheduleCtrl'; // jshint ignore:line

export default function EditScheduleCtrl(
  $rootScope, $scope, $filter, $state, $stateParams, $log, $mdDialog, $mdToast,
  $timeout, scheduleService, appConstants, unregister
) {
  "ngInject";

  const vm = this;

  var listeners = [];
  var orgSchedule;
  var savedSchedule;
  const timezoneId = AdminService.getVenueTimezoneId();
  var todaysDate = DateUtilsService.getVenueTime(timezoneId);

  //-- define public properties
  vm.sectionLayouts = [];
  vm.SECTION_CLOSED = 'closed';
  vm.SECTION_NOT_USED = 'not-used';
  vm.saveDate = DateUtilsService.dateToIdStr(todaysDate);
  vm.effectiveFromDate = todaysDate;
  vm.servicesStates = {};
  vm.minBookingDuration = 30;
  vm.WHOLE_NUMBER_REGEX = WHOLE_NUMBER_REGEX;

  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SAVED = 2;
  vm.ERROR = 3;
  vm.CONFLICTS = 4;
  vm.state = vm.LOADING;
  vm.bookingIntervals = scheduleService.bookingIntervals;
  vm.serviceTypes = scheduleService.serviceTypes;
  vm.serviceColours = scheduleService.serviceColours;
  //-- define public methods
  vm.save = save;
  vm.cancel = cancel;
  vm.tryAgain = tryAgain;
  vm.open = open;
  vm.close = close;
  vm.toggleServiceState = toggleServiceState;
  vm.updateCustomIntervals = updateCustomIntervals;
  vm.deleteService = deleteService;
  vm.addService = addService;
  vm.checkClose = checkClose;
  vm.checkServiceStartTime = checkServiceStartTime;
  vm.checkServiceEndTime = checkServiceEndTime;
  vm.checkDateDay = checkDateDay;
  vm.printConflicts = printConflicts;
  vm.addCustomDuration = addCustomDuration;
  vm.deleteCustomDuration = deleteCustomDuration;
  vm.nextTab = nextTab;
  vm.previousTab = previousTab;
  vm.maxPeoplePerOnlineBooking = AdminService.getVenue().maxPeoplePerOnlineBooking || 9999;
  listeners.push($scope.$on('$destroy', () => unregister(listeners)));

  if ($stateParams.id) {
    getSections();
  } else {
    $state.go('settings.schedule');
  }

  function nextTab(serviceIndex) {
    vm['tabs-' + serviceIndex].selectedIndex++;
  }

  function previousTab(serviceIndex) {
    vm['tabs-' + serviceIndex].selectedIndex--;
  }

  function printConflicts() {
    window.print();
  }

  function checkDateDay(date, service, dateParam) {
    service[dateParam] = DateUtilsService.checkDateDay(date, todaysDate);
  }

  function open() {
    vm.schedule.isOpen = true;
  }

  function close() {
    vm.schedule.isOpen = false;
  }

  function getSections() {
    SectionLookupService.getSections().then(function (sections) {
      vm.sections = sections;
      getLayouts();
    }).catch(function () {
      $log.error('Failed to get all scections');
    });

  }

  $scope.range = function (min, max, step) {
    step = step || 1;
    var input = [];
    for (var i = min; i <= max; i += step) {
      input.push(i);
    }
    return input;
  };

  $scope.getdate = function (dt, minutes) {
    return new Date(dt.getTime() + minutes * 60000);
  };

  function toggleServiceState(index) {
    vm.servicesStates[index] = !vm.servicesStates[index];
    vm.showMarkdown = false;
    $timeout(function () {
      vm.showMarkdown = true;
    }, 50);
  }

  function updateCustomIntervals(intervals) {
    vm.schedule.services.map((service) => {
      if (service.enableCustomPaxPerIntervals) {
        service.intervalsCustom = CustomIntervalsService.getCustomIntervalsForService(service, intervals);
      }
      return service;
    })
  }


  $rootScope.$on('dateChangedInDirective', function (evt, data) { // To get the changed date event from the DateTimePopUp Directive.
    if (vm.schedule && (data === 'startTime' || data === 'endTime')) {
      updateCustomIntervals(vm.schedule.boookingInterval)
    }
  });

  function getLayouts() {
    LayoutsService.getAllLayouts().then(function (layouts) {
      var sectionLayouts = {};
      for (var i = layouts.length - 1; i >= 0; i--) {
        var layout = layouts[i];
        var idParts = layout._id.split('_');
        idParts.pop();
        layout.layoutId = idParts.join('_');
        if (!sectionLayouts[layout.sectionId]) {
          sectionLayouts[layout.sectionId] = [];
        }
        sectionLayouts[layout.sectionId].push(layout);
      }
      vm.sectionLayouts = sectionLayouts;
      getSchedule();
    }).catch(function () {
      $log.error('Failed to get all layouts');
    });
  }

  function getSchedule() {
    var id = decodeURIComponent($stateParams.id);
    scheduleService.getScheduleById(id).then(function (schedule) {
      orgSchedule = ObjectCopyService.angularSafeCopy(schedule);
      parseSchedule(schedule);
    }).catch(function (err) {
      $log.error('Failed to getScheduleById', err);
    });
  }

  function checkClose(openDate, dataObj, closeParamName) {
    var closeStr = $filter('date')(dataObj[closeParamName], 'HH:mm');
    var closeDate = DateUtilsService.closeTimesToDate(closeStr, openDate);
    dataObj[closeParamName] = closeDate;
  }

  /**
   * Make sure you are open for the service
   * @param {Date} startTime The time the service starts
   */
  function checkServiceStartTime(date, service, dateParam) {
    setFirstServieTime();
    checkDateDay(date, service, dateParam);
  }

  /**
   * Make sure you are open for the service
   * @param {Date} endTime The time the service starts
   */
  function checkServiceEndTime(openDate, dataObj, closeParamName) {
    checkClose(openDate, dataObj, closeParamName);
    setLastServieTime();
  }

  function setFirstServieTime() {
    var services = $filter('orderBy')(vm.schedule.services, 'startTime');
    vm.firstServieTime = services[0].startTime;
  }

  function setLastServieTime() {
    var services = $filter('orderBy')(vm.schedule.services, 'startTime');
    vm.lastServieTime = services[services.length - 1].endTime;
  }

  function parseSchedule(schedule) {
    var timeNow = new Date();
    timeNow.setSeconds(0);
    timeNow.setMilliseconds(0);
    schedule.services = $filter('orderBy')(schedule.services, 'startTime');
    for (var i = schedule.services.length - 1; i >= 0; i--) {
      var service = schedule.services[i];
      // service.hasMenuOptionsError = false;
      service.index = i;
      service.selectedLayouts = {};
      if (!vm['tabs-' + service.index]) {
        vm['tabs-' + service.index] = {};
      }
      vm['tabs-' + service.index].selectedIndex = 0;
      for (var s = service.sectionLayouts.length - 1; s >= 0; s--) {
        var sectionLayout = service.sectionLayouts[s];
        if (sectionLayout.sectionNotUsed) {
          service.selectedLayouts[sectionLayout.sectionId] = vm.SECTION_NOT_USED;
        } else {
          service.selectedLayouts[sectionLayout.sectionId] = sectionLayout.layoutId;
        }
      }
      vm.sections = $filter('orderBy')(vm.sections, 'order');
      for (var f = vm.sections.length - 1; f >= 0; f--) {
        var section = vm.sections[f];
        if (!service.selectedLayouts[section._id]) {
          service.selectedLayouts[section._id] = 'closed';
        }
      }
      if (i === 0) {
        vm.firstServieTime = service.startTime;
      }
      if (i === schedule.services.length - 1) {
        vm.lastServieTime = service.endTime;
      }

      if (service.enableCustomPaxPerIntervals && service.enableCustomPaxPerIntervals == true) {


      } else {


        service.intervalsCustom = [];

        var rangeer = $scope.range(0, (((service.endTime - service.startTime) / 60000) / schedule.boookingInterval), 1);


        for (var ii = 0; ii < rangeer.length; ii++) {
          var servicex = {
            intervalDuration: schedule.boookingInterval,
            times: moment($scope.getdate(service.startTime, (ii * schedule.boookingInterval))).format('h:mm a'),
            values: ''
          };
          service.intervalsCustom.push(servicex);
        }
      }
    }

    /**
     * @todo: when this file is rewritten to react / TS vm.schedule should use the interface IEditScheduleService,
     * not IDiaryService, as the times are saved as strings.
     */
    vm.schedule = schedule;
    vm.state = vm.ENTER;
  }

  function addService() {
    if (vm.schedule && vm.schedule.services) {
      var lastService;
      if (vm.schedule.services.length) {
        lastService = vm.schedule.services[vm.schedule.services.length - 1];
      }
      var startTime = new Date();
      startTime.setHours(8);
      startTime.setMinutes(0);
      startTime.setSeconds(0);
      startTime.setMilliseconds(0);

      var bookingDuration = 90;
      if (lastService) {
        // if there is a service before this one start right after it
        startTime = (lastService.endTime) ? lastService.endTime : startTime;
        bookingDuration = (lastService.bookingDuration) ? lastService.bookingDuration : bookingDuration;
      }
      // make the end time 3hrs after the start time by defualt
      var endTime = new Date(startTime.getTime());
      endTime.setHours(endTime.getHours() + 3);

      var lastBookingTime = new Date(endTime.getTime());
      lastBookingTime.setMinutes(lastBookingTime.getMinutes() - 15);


      var service = {
        _id: PouchLoadService.getNewId(['service']),
        index: vm.schedule.services.length,
        name: '',
        startTime: startTime,
        lastBookingTime: lastBookingTime,
        endTime: endTime,
        online: true,
        bookingDuration: bookingDuration,
        sectionLayouts: [],
        paymentDetails: {
          paymentType: appConstants.Payment.PaymentTypes.NoPayment,
          peopleRequired: 1
        }
      };

      vm.servicesStates[vm.schedule.services.length] = true;
      vm.schedule.services.push(service);
      vm['tabs-' + service.index] = {
        selectedIndex: 0
      };
    }
  }

  function deleteService(evt, service, index) {
    var confirm = $mdDialog.confirm()
      .parent(angular.element(document.body))
      .title('Delete Service?')
      .content('Are you sure you would like to delete the ' + service.name + ' service')
      .ariaLabel('Delete Servive')
      .ok('Yes')
      .cancel('No')
      .targetEvent(evt);
    $mdDialog.show(confirm).then(function () {
      var deleteIndex = vm.schedule.services.map(function (service) {
        return service.index;
      }).indexOf(index);
      vm.schedule.services.splice(deleteIndex, 1);
      setFirstServieTime();
      setLastServieTime();
    });
  }

  function tryAgain() {
    vm.state = vm.ENTER;
  }

  function cancel() {
    $state.go('settings.schedule');
  }

  function save(evt, isValid) {


    if (isValid) {
      // format schedule
      var schedule = ObjectCopyService.angularSafeCopy(vm.schedule);
      // update the schedule id.
      var idParts = schedule._id.split('_');
      var dateStr = idParts[idParts.length - 1];

      if (dateStr !== vm.saveDate) {
        delete schedule._rev; // we are going to save this as a new schedule so remove the revision
        idParts.pop();
        idParts.push(vm.saveDate);
        schedule._id = idParts.join('_');
      }

      for (var i = 0; i < schedule.services.length; i++) {
        var service = schedule.services[i];
        service.startTime = DateUtilsService.dateToTimeStr(service.startTime, 'HH:mm');
        service.lastBookingTime = DateUtilsService.dateToTimeStr(service.lastBookingTime, 'HH:mm');
        service.endTime = DateUtilsService.dateToTimeStr(service.endTime, 'HH:mm');

        // Schedule should not be saved if wrong payment type is selected - PaymentTypes.MenuOptions should NOT be sent to backend
        if (!vm.isWrongPaymentType) { // If wrong Payment type exist on any one service it should throw error - Check so that the flag retains its value if found
          let isWrongPaymentAdditional = false;
          const isWrongPaymentService = service.paymentDetails && service.paymentDetails.paymentType === PaymentTypes.MenuOptions;
          if (service.additionalPaymentDetails && service.additionalPaymentDetails.length) {
            isWrongPaymentAdditional = service.additionalPaymentDetails.some(additionalPayment => additionalPayment.paymentType === PaymentTypes.MenuOptions);
          }
          vm.isWrongPaymentType = isWrongPaymentService || isWrongPaymentAdditional;
        }

        // build sectionLayouts
        var sectionLayouts = [];
        for (var sectionId in service.selectedLayouts) {
          var layoutId = service.selectedLayouts[sectionId];
          if (layoutId === vm.SECTION_CLOSED) {
          } else if (layoutId === vm.SECTION_NOT_USED) {
            sectionLayouts.push({
              layoutId: null,
              sectionId: sectionId,
              sectionNotUsed: true,
              sectionClosed: false
            });
          } else {
            sectionLayouts.push({
              layoutId: layoutId,
              sectionId: sectionId,
              sectionNotUsed: false,
              sectionClosed: false
            });
          }
        }
        service.sectionLayouts = sectionLayouts;
        delete service.selectedLayouts;
      }

      if (!vm.isWrongPaymentType) {
        schedule.services = $filter('orderBy')(schedule.services, 'startTime');
        var timeNow = DateUtilsService.getVenueTime(timezoneId);

        BookingsAffectedService.checkSchedule(orgSchedule, ObjectCopyService.angularSafeCopy(schedule), timeNow).then(function (effectedBookings) {
          if (!effectedBookings || (effectedBookings.length === 0)) {
            // There are not conflicts
            doSave(schedule);
          } else {
            var bookingConflicts = effectedBookings.map(function (effected) {
              return effected.booking;
            });

            // show a confirm dialog
            $mdDialog.show({
              controller: 'AffectedBookingsConfirmCtrl',
              controllerAs: 'vm',
              templateUrl: 'app/settings/confirmDialogs/affectedBookingsConfirm.html',
              parent: angular.element(document.body),
              targetEvent: evt,
              locals: {
                bookingConflicts: bookingConflicts
              },
              clickOutsideToClose: true
            })
              .then(function () {
                doSave(schedule);
              });
          }
        });
      } else {
        console.error('Wrong Payment type selected')
      }

    } else {
      vm.displayErrors = true;
      for (var key in vm.servicesStates) {
        var serviceForm = $scope.editForm['service-' + key];
        if (!serviceForm.$valid) {
          vm.servicesStates[key] = true;
          var forms = [serviceForm.info, serviceForm.time, serviceForm.details, serviceForm.sections, serviceForm.payment];
          for (var j = 0; j < forms.length; j++) {
            if (!forms[j].$valid) {
              vm['tabs-' + key].selectedIndex = j;
              break;
            }
          }
        }
      }
    }
  }

  function doSave(schedule) {
    vm.state = vm.LOADING;
    scheduleService.save(schedule).then(function () {

      ScheduleFilterService.addToSchedulesByDayNum(schedule);

      $mdToast.show(
        $mdToast.simple()
          .content('Schedule Saved')
          .position('bottom right')
          .theme('saved')
          .hideDelay(3000)
      );
      savedSchedule = schedule;
      var timeNow = DateUtilsService.getVenueTime(timezoneId);
      BookingsAffectedService.checkSchedule(orgSchedule, ObjectCopyService.angularSafeCopy(savedSchedule), timeNow).then(function (effectedBookings) {
        if (!effectedBookings || (effectedBookings.length === 0)) {
          // There are not conflicts
          $state.go('settings.schedule');
        } else {
          vm.state = vm.CONFLICTS;
          vm.bookingConflicts = effectedBookings;
          filterConflicts();
          listeners.push($rootScope.$on('booking-edited', reCheckConfict));
          listeners.push($rootScope.$on('booking-new', reCheckConfict));
        }
      });

      ServiceGroupsService.updateScheduleServiceGroupsByName(ObjectCopyService.angularSafeCopy(schedule.services))
        .pipe(first())
        .subscribe(() => console.log('success'), err => console.warn(err));

    }).catch(function (err) {
      $log.error(err);
      vm.state = vm.ERROR;
    });
  }

  function reCheckConfict(evt, booking) {
    BookingsAffectedService.checkSchedule(orgSchedule, ObjectCopyService.angularSafeCopy(savedSchedule), new Date(), [booking]).then(function (effectedBookings) {
      if (!effectedBookings || (effectedBookings.length === 0)) {
        // remove the effectted booking from the conflict list
        var conflictIds = vm.bookingConflicts.map(function (conflictItem) {
          return conflictItem.booking._id;
        });
        var conflictId = conflictIds.indexOf(booking._id);
        if (conflictId !== -1) {
          vm.bookingConflicts.splice(conflictId, 1);
        }
        filterConflicts();
      }
    });
  }

  function filterConflicts() {
    if (vm.bookingConflicts && vm.bookingConflicts.length) {
      vm.timeConflicts = $filter('filter')(vm.bookingConflicts, {
        timeEffected: true
      });
      vm.tableConflicts = $filter('filter')(vm.bookingConflicts, {
        timeEffected: false
      });
      vm.serviceConflict = $filter('filter')(vm.bookingConflicts, {
        serviceEffected: false
      });
    } else {
      vm.timeConflicts = [];
      vm.tableConflicts = [];
      vm.serviceConflict = [];
    }
  }

  function addCustomDuration(service) {
    if (!service.customDurations) {
      service.customDurations = [];
    }
    service.customDurations.push({
      minPeople: null,
      maxPeople: null,
      bookingDuration: null
    });
  }

  function deleteCustomDuration(service, index) {
    service.customDurations.splice(index, 1);
  }
}
